import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../redux/ducks/user";
import { ReducersTypes } from "../../../redux/reducers/Models";
import { validateCPF, validateEmail, validatePhone } from "@/utils/functions";
import UserInfoView from "./view";
import useRedirect from "../../../hooks/useRedirect";
import { useNavigate, useParams } from "react-router-dom";

export default function UserInfo() {
  useRedirect("checkout/user");

  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const goBack = () => navigate(-1);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    dispatch(setUser({ [name]:  value}));
  }

  const getIsDisabled = () => {
    if (!validateCPF(user?.document as string) || !user?.name || !validatePhone(user?.phone as string) || !validateEmail(user?.email as string)) return true;
    return false;
  }

  const submit = () => {
    if (getIsDisabled()) return;
    
    if (id === "pix") navigate('/checkout/pix');

    if (id === "card") navigate('/checkout/card');
  }
  
  return <UserInfoView 
    goBack={goBack}
    user={user}
    onChange={onChange}
    submit={submit}
    isDisabled={getIsDisabled()}
  />;
}
